"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollView = exports.ScrollViewDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_icons_1 = require("../../hooks/use-icons");
var icon_1 = require("./icon");
exports.ScrollViewDefaultProps = {
  fadeSize: '60px'
};
// -------- Styles ---------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow: hidden;\n    position: relative;\n    display: flex;\n  "], ["\n    overflow: hidden;\n    position: relative;\n    display: flex;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(10))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FadeStyles = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 50;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(100% - 10px);\n  background: linear-gradient(to top, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n\n  ", "\n"], ["\n  position: absolute;\n  z-index: 50;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(100% - 10px);\n  background: linear-gradient(to top, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n\n  ", "\n"])), function (props) {
  return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: ", ";\n  "], ["\n    height: ", ";\n  "])), props.fadeSize);
});
var ArrowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    z-index: 100;\n  "], ["\n    z-index: 100;\n  "])))
});
// -------- Components ---------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Content: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Fade: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles),
  Arrow: (0, styled_components_1.default)(icon_1.Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ArrowStyles)
};
var ScrollView = function (props) {
  var className = props.className,
    fadeSize = props.fadeSize,
    children = props.children;
  var Icons = (0, use_icons_1.useIcons)();
  var scrollRef = (0, react_1.useRef)();
  var sizeRef = (0, react_1.useRef)();
  return react_1.default.createElement(My.Container, {
    fadeSize: fadeSize,
    className: className
  }, react_1.default.createElement(My.Body, {
    ref: scrollRef,
    fadeSize: fadeSize
  }, react_1.default.createElement(My.Content, {
    ref: sizeRef
  }, children)), react_1.default.createElement(My.Fade, {
    fadeSize: fadeSize
  }, react_1.default.createElement(My.Arrow, {
    size: 18,
    color: "textSubtle"
  }, react_1.default.createElement(Icons.ChevronDown, null))));
};
exports.ScrollView = ScrollView;
exports.ScrollView.defaultProps = exports.ScrollViewDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;